import * as types from './meetings-simple.types';
import * as constants from './meetings-simple.constants';
import {
  IMeetingSimple,
  IMeetingSimpleCreateForm,
  IMeetingSimpleUpdate,
} from '../../../resource/meeting-simple/meeting-simple.types';
import { ISession } from '../../../resource/session/session.types';
import { IMeetingParticipantsUpdateForm } from '../../../resource/meeting/meeting.types';
import { IMeetingFolderUpdateForm } from '../../../resource/meeting-folder/meeting-folder.types';
import { IUser } from '../../../resource/user/user.types';

export const fetchMeetingsSimple = (): types.IFetchMeetingsSimple => ({
  type: constants.FETCH_MEETINGS_SIMPLE,
});

export const createMeetingSimple = (meetingSimple: IMeetingSimpleCreateForm): types.ICreateMeetingSimple => ({
  type: constants.CREATE_MEETING_SIMPLE,
  payload: meetingSimple,
});

export const updateMeetingSimple = (
  meetingSimpleId: IMeetingSimple['id'],
  meetingSimple: IMeetingSimpleUpdate,
): types.IUpdateMeetingSimple => ({
  type: constants.UPDATE_MEETING_SIMPLE,
  payload: {
    id: meetingSimpleId,
    data: meetingSimple,
  },
});

export const updateMeetingSimpleComplete = (): types.IUpdateMeetingSimpleComplete => ({
  type: constants.UPDATE_MEETING_SIMPLE_COMPLETE,
});

export const clearUpdateMeetingSimpleComplete = (): types.IClearUpdateMeetingSimpleComplete => ({
  type: constants.CLEAR_UPDATE_MEETING_SIMPLE_COMPLETE,
});

export const updateFolderForMeeting = (
  meetingId: IMeetingSimple['id'],
  payload: IMeetingFolderUpdateForm,
): types.IUpdateMeetingSimpleFolder => ({
  type: constants.UPDATE_MEETING_SIMPLE_FOLDER,
  payload: {
    id: meetingId,
    data: payload,
  },
});

export const updateMeetingParticipants = (
  meetingSimpleId: IMeetingSimple['id'],
  updatedMeetingParticipants: IMeetingParticipantsUpdateForm,
): types.IUpdateMeetingParticipants => ({
  type: constants.UPDATE_MEETING_PARTICIPANTS,
  payload: {
    id: meetingSimpleId,
    data: updatedMeetingParticipants,
  },
});

export const sendMessageToMeetingMembers = (
  sender_id: IUser['id'],
  receiver_ids: IUser['id'][],
  meeting_id: IMeetingSimple['id'],
  message: string,
): types.ISendMessageToMeetingMembers => ({
  type: constants.SEND_MESSAGE_TO_MEETING_MEMBERS,
  payload: {
    sender_id,
    receiver_ids,
    meeting_id,
    message,
  },
});

export const deleteMeetingSimple = (meetingSimpleId: IMeetingSimple['id']): types.IDeleteMeetingSimple => ({
  type: constants.DELETE_MEETING_SIMPLE,
  payload: meetingSimpleId,
});

export const startMeetingSimpleSession = (meetingId: IMeetingSimple['id']): types.IStartMeetingSimpleSession => ({
  type: constants.START_MEETING_SIMPLE_SESSION,
  payload: { meetingId },
});

export const finishMeetingSession = (
  meetingId: IMeetingSimple['id'],
  sessionId: ISession['id'],
  cancelled: boolean,
): types.IFinishMeetingSimpleSession => ({
  type: constants.FINISH_MEETING_SIMPLE_SESSION,
  payload: {
    meetingId,
    sessionId,
    cancelled,
  },
});

export const storeMeetingsSimple = (meetingsSimpleIds: IMeetingSimple['id'][]): types.IStoreMeetingSimple => ({
  type: constants.STORE_MEETING_SIMPLE,
  payload: meetingsSimpleIds,
});
export const clearMeetingSimple = (): types.IClearMeetingSimple => ({
  type: constants.CLEAR_MEETING_SIMPLE,
});

export const storeAccounts = (accountIds: IMeetingSimple['id'][]): types.IStoreMeetingSimple => ({
  type: constants.STORE_ACCOUNTS,
  payload: accountIds,
});
export const clearAccount = (): types.IClearMeetingSimple => ({
  type: constants.CLEAR_ACCOUNTS,
});
export const storeTeams = (teamIds: IMeetingSimple['id'][]): types.IStoreMeetingSimple => ({
  type: constants.STORE_TEAMS,
  payload: teamIds,
});
export const clearTeam = (): types.IClearMeetingSimple => ({
  type: constants.CLEAR_TEAMS,
});

export const storeNextMeeting = (nextMeeting: string): types.IStoreNextMeeting => ({
  type: constants.STORE_NEXT_MEETING,
  payload: nextMeeting,
});

export const clearNextMeeting = (): types.IClearNextMeeting => ({
  type: constants.CLEAR_NEXT_MEETING,
});

export const storeStartedMeetingsSimple = (startedMeetings: IMeetingSimple['id'][]): types.IStoreStartedMeetings => ({
  type: constants.STORE_STARTED_MEETINGS,
  payload: startedMeetings,
});

export const clearStartedMeetingsSimple = (): types.IClearStartedMeetings => ({
  type: constants.CLEAR_STARTED_MEETINGS,
});

export const storeFilteredMeetingsSimple = (
  filteredMeetings: IMeetingSimple['id'][],
): types.IStoreFilteredMeetings => ({
  type: constants.STORE_FILTERED_MEETINGS,
  payload: filteredMeetings,
});

export const clearFilteredMeetingsSimple = (): types.IClearFilteredMeetings => ({
  type: constants.CLEAR_FILTERED_MEETINGS,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});

export const fetchLiveSessions = () => ({
  type: constants.FETCH_LIVE_MEETINGS,
});

export const saveLiveSessions = (liveSessions: ISession[]) => ({
  type: constants.SAVE_LIVE_MEETINGS,
  payload: liveSessions,
});

export const joinMeeting = (session: ISession): types.IJoinMeeting => ({
  type: constants.JOIN_MEETING,
  payload: {
    session,
  },
});
